import React from "react";
import styled from "styled-components";
import LoaderGif from "../assets/images/Preloader.gif";


const StyledLoading = styled.div`
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 999999999;
  background-image: url(${LoaderGif});
  background-repeat: no-repeat;
  background-position: center;
  background-color: rgba(255, 255, 255, 0.7);
`;
const Loading = () => {
  return (
    <StyledLoading />
  );
};
export default Loading;
